import amitabh from './amitabh.jpg';
import tiger from './tiger.jpg';
import johnny from './johnny.jpg';
import hrithik from './hrithik.jpg';

export const title = 'Which Bollywood leading man are you?';
export const results = [
  {
    name: 'Amitabh Bachchan',
    description: 'You are a born leader with a classy personality.',
    image: amitabh,
  },
  {
    name: 'Tiger Shroff',
    description: 'You are tough stuff and take pride in fitness.',
    image: tiger,
  },
  {
    name: 'Johnny Lever',
    description: 'You are the life of the party and always make people laugh.',
    image: johnny,
  },
  {
    name: 'Hrithik Roshan',
    description: 'Wow, you can really dance!',
    image: hrithik,
  },
];

export const questions = [
  {
    Question: 'After a long day, how do you like to unwind?',
    Choices: [
      'A single malt and a piece of classic literature',
      'Lifting cinder blocks above my head',
      'Practicing funny faces in the mirror',
      'Dancing!',
    ],
  },
  {
    Question: 'How do you like to take your chai?',
    Choices: [
      'Classic -- the way my grandmother made it',
      'With steroids',
      'Dark',
      'With a beautiful lady',
    ],
  },
  {
    Question:
      'You\'re walking down the street and are confronted by a mugger.  What do you do?',
    Choices: [
      'I would speak to the young man with reason and show him the error of his ways',
      '360 spin kick to the head',
      'I\'d try to make him laugh, and when he was confused, I\'d run away',
      'I would challenge him to a dance-off',
    ],
  },
  {
    Question: 'What do you expect your child to be when they grow up?',
    Choices: [
      'Doctor',
      'Engineer',
      'Hotel manager',
      'Whatever their heart desires',
    ],
  },
  {
    Question: 'If my neighbor did not like the samosas I brought to a party:',
    Choices: [
      'I would gracefully apologize and suggest I would perhaps bring some Johnny Walker Black next time',
      'I would claim they are high-protein samosas for bodybuilding, so they taste different',
      'I would feed them to the neighbor\'s dog',
      'I would re-enact a demonstration from my favorite cooking show explaining how I made them',
    ],
  },
  {
    Question: 'For TV, I like',
    Choices: [
      'Dish Network -- classic films!',
      'Direct TV -- sports!',
      'YouTube -- Dogs stealing pakoras!',
      'Hotstar -- Old episodes of Indian Idol!',
    ],
  },
  {
    Question: "If my child wasn't listening to me, I would discipline them by:",
    Choices: [
      'Making them run ten kilometers',
      'Giving them a nice smack to the face',
      'Sending them to Dadi\'s or Nani\'s house',
      'Putting mirch in their mouth',
    ],
  },
  {
    Question: 'My ideal family Saturday is:',
    Choices: [
      'Macy\'s to look at pants, then snacks at Uncle\'s',
      'Uphill mountain walking',
      'Miniature golf followed by going out for dosas',
      'Bhangra party!',
    ],
  },
  {
    Question: 'My favorite clothing brand?',
    Choices: [
      'Polo - I love their shirts!',
      'Polo - I love their shorts!',
      'Polo - I love their sandals!',
      'Polo - I love their scarves!',
    ],
  },
];
